import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Mui } from "@osu/react-ui";
import { selectChipsDetails } from "../../../../util/selectors";

function Chips({ year, period, ...rest }) {
  const details = useSelector((state) =>
    selectChipsDetails(state, year, period)
  );
  
  const hash = [year, period].join("#");
  return (
    <Fragment>
      {details.map(
        ({ primary, secondary, label, color, size = "small", variant = "outlined" }, idx) => (
          <Mui.Chip
            key={hash + "-reporting-chip-" + idx}
            size={size}
            variant={variant}
            sx={{
              ml: 0,
              mr: 1,
              mt: 0,
            }}
            color={color}
            label={label}
            primary={primary}
            secondary={secondary}
          />
        )
      )}
    </Fragment>
  );
}

export default Chips;
